function epochMs(value) {
  const parsed = Date.parse(String(value || ""));
  return Number.isFinite(parsed) ? parsed : null;
}

export function remoteTombstoneDeletesLocal(deletedAt, localUpdatedAt) {
  const deletedAtEpochMs = epochMs(deletedAt);
  if (deletedAtEpochMs == null) return false;
  const localUpdatedAtEpochMs = epochMs(localUpdatedAt);
  return localUpdatedAtEpochMs == null || deletedAtEpochMs >= localUpdatedAtEpochMs;
}
